import React, { useEffect, useMemo, useState } from "react";
import { Pressable, TouchableOpacity, useWindowDimensions, View } from "react-native";
import ThemeProvider from "@voltmoney/theme";
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens, TextAlignTokens, TypographyTypeDLS, } from "@voltmoney/schema";
import { Typography } from "../../../typography/Typography";
import { Space } from "../../../space/Space";
import { Image } from "../../../image/Image";
import { Icon } from "../../../icon/Icon";
import { Button } from "../../../button/Button";
import { addCommasToNumber } from "../../utils";
import { formatDate } from "./util";
import TooltipComp from "../../TooltipComp";
const CgtcSummaryPage = ({ toDate, fromDate, pan, phone, data, downloadAction, editAction, toolTipAmplitudeEvent, triggerAction }) => {
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    const [_isMobile, setIsMobile] = useState(false);
    const scaledSize = useWindowDimensions();
    const [focusToolTipName, setFocusToolTipName] = useState(undefined);
    const [viewTooltipInMobile, setViewToolTipInMobile] = useState(false);
    const [downloadBtnLoading, setDownloadButtonLoading] = useState(false);
    useEffect(() => {
        if (scaledSize?.width < 450) {
            setViewToolTipInMobile(true);
        }
        else {
            setViewToolTipInMobile(false);
        }
        if (scaledSize?.width < 600) {
            setIsMobile(true);
        }
        else {
            setIsMobile(false);
        }
    }, [scaledSize]);
    const [_data, setData] = useState(data);
    useEffect(() => {
        setData(data);
    }, [data]);
    const renderToolTip = (keyName) => {
        switch (keyName) {
            case 'equityShortTermCapitalGain':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: 'For holding period of less than a year on equity focused mutual funds.' })), leftShiftContent: -50, width: 200 }));
                break;
            case 'equityLongTermCapitalGain':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: 'For holding period of more than a year on equity focused mutual funds. Upto ₹1 lac per year is tax exempted. ' })), leftShiftContent: -50, width: 200 }));
                break;
            case 'equityLongTermCapitalTaxPercentage':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: 'Excludes cess and surcharges.' })), leftShiftContent: -50, width: 200 }));
                break;
            case 'equityShortTermCapitalTaxPercentage':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: 'Excludes cess and surcharges.' })), leftShiftContent: -50, width: 200 }));
                break;
            case 'nonEquityLongTermCapitalGain':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: 'For holding period of more than 3 years on debt (units purchased before 1st Apr 2023) or debt oriented hybrid funds.' })), leftShiftContent: -50, width: 200 }));
                break;
            case 'nonEquityLongTermCapitalGainAsPerTaxSlab':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: '1. Holding period of less than 3 years on debt (units purchased before 1st Apr 2023) or debt oriented hybrid funds. \n' +
                                '2. Regardless of holding period on debt mutual fund units bought after 1st Apr 2023. \n' })), leftShiftContent: -50, width: 200 }));
                break;
            case 'nonEquityLongTermCapitalTaxPercentage':
                return (React.createElement(TooltipComp, { children: React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: 'Indexation benefits allow investors to adjust the cost of investment for inflation with the help of a price index.' })), leftShiftContent: -50, width: 200 }));
                break;
            default:
                return (React.createElement(React.Fragment, null));
                break;
        }
    };
    const renderDivider = () => {
        return (React.createElement(View, { style: {
                height: 1,
                width: '100%',
                backgroundColor: colorMapping[ColorTokens.Grey_Chalk]
            } }));
    };
    const getToolTipCount = (keyName) => {
        switch (keyName) {
            case 'equityShortTermCapitalGain':
                return 1;
            case 'equityShortTermCapitalTaxPercentage':
                return 2;
            case 'equityLongTermCapitalGain':
                return 3;
            case 'equityLongTermCapitalTaxPercentage':
                return 4;
            case 'nonEquityLongTermCapitalGain':
                return 5;
            case 'nonEquityLongTermCapitalTaxPercentage':
                return 6;
            case 'nonEquityLongTermCapitalGainAsPerTaxSlab':
                return 7;
            default:
                return 0;
        }
    };
    const renderItems = ({ label, value, keyName, breakLabel1, breakLabel2 }) => {
        const showMobileView = ((keyName === 'nonEquityLongTermCapitalGain' ||
            keyName === 'nonEquityLongTermCapitalGainAsPerTaxSlab') &&
            viewTooltipInMobile);
        return (React.createElement(View, { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center'
            } },
            React.createElement(View, { style: {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    } }, (showMobileView) ?
                    React.createElement(View, { style: {
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        } },
                        React.createElement(Typography, { label: `${breakLabel1}`, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(View, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            } },
                            React.createElement(Typography, { label: `${breakLabel2}`, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                            React.createElement(Space, { size: SizeTypeTokens.SM }),
                            React.createElement(TouchableOpacity, { onPress: () => {
                                    if (focusToolTipName === keyName) {
                                        setFocusToolTipName(undefined);
                                    }
                                    else {
                                        setFocusToolTipName(keyName);
                                    }
                                } },
                                focusToolTipName === keyName &&
                                    renderToolTip(keyName),
                                React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, size: IconSizeTokens.LG, color: ColorTokens.Grey_Charcoal })))) :
                    React.createElement(React.Fragment, null,
                        React.createElement(Typography, { label: `${label}`, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Charcoal }),
                        React.createElement(Space, { size: SizeTypeTokens.SM }),
                        React.createElement(TouchableOpacity, { onPress: () => {
                                toolTipAmplitudeEvent &&
                                    triggerAction({
                                        ...toolTipAmplitudeEvent,
                                        payload: {
                                            ...toolTipAmplitudeEvent.payload,
                                            tooltip_num: getToolTipCount(keyName)
                                        }
                                    });
                                if (focusToolTipName === keyName) {
                                    setFocusToolTipName(undefined);
                                }
                                else {
                                    setFocusToolTipName(keyName);
                                }
                            } },
                            focusToolTipName === keyName &&
                                renderToolTip(keyName),
                            React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, size: IconSizeTokens.LG, color: ColorTokens.Grey_Charcoal }))))),
            React.createElement(View, { style: {
                    width: 100,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-end'
                } },
                React.createElement(Typography, { label: `${value}`, typeDLS: TypographyTypeDLS.B2M, color: ColorTokens.Grey_Night }))));
    };
    const renderEquity = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { label: 'Equity', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, null,
                _data?.equityShortTermCapitalGain === null &&
                    _data?.equityLongTermCapitalGain === null ? (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: {
                            width: '100%',
                        } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `You have no capital gains on equity mutual funds in financial year ${toDate.substring(toDate.length - 4)}-${fromDate.substring(fromDate.length - 2)}`, color: ColorTokens.Grey_Charcoal })))) : (React.createElement(View, { style: {
                        width: '100%',
                        borderWidth: 1,
                        borderRadius: 8,
                        borderColor: colorMapping[ColorTokens.Grey_Chalk],
                        padding: 16
                    } },
                    (_data.equityShortTermCapitalGain !== null) &&
                        React.createElement(React.Fragment, null,
                            renderItems({
                                label: 'Short term capital gain',
                                value: `₹${addCommasToNumber(_data?.equityShortTermCapitalGain)}`,
                                keyName: 'equityShortTermCapitalGain'
                            }),
                            React.createElement(Space, { size: SizeTypeTokens.XL })),
                    _data?.equityShortTermCapitalTaxPercentage !== null &&
                        React.createElement(React.Fragment, null,
                            renderItems({
                                label: 'Tax%*',
                                value: `${_data?.equityShortTermCapitalTaxPercentage}%`,
                                keyName: 'equityShortTermCapitalTaxPercentage'
                            }),
                            React.createElement(Space, { size: SizeTypeTokens.XL })),
                    renderDivider(),
                    React.createElement(Space, { size: SizeTypeTokens.XL }),
                    _data?.equityLongTermCapitalGain !== null &&
                        React.createElement(React.Fragment, null,
                            renderItems({
                                label: 'Long term capital gain',
                                value: `₹${addCommasToNumber(_data?.equityLongTermCapitalGain)}`,
                                keyName: 'equityLongTermCapitalGain'
                            }),
                            React.createElement(Space, { size: SizeTypeTokens.XL })),
                    _data?.equityLongTermCapitalTaxPercentage !== null &&
                        React.createElement(React.Fragment, null, renderItems({
                            label: 'Tax%*',
                            value: `${_data?.equityLongTermCapitalTaxPercentage}%`,
                            keyName: 'equityLongTermCapitalTaxPercentage'
                        })))),
                React.createElement(View, null))));
    };
    const renderNonEquity = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { label: 'Non equity', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night }),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(View, { style: {
                    width: '100%'
                } }, _data?.nonEquityLongTermCapitalGain === null &&
                _data?.nonEquityLongTermCapitalGainAsPerTaxSlab === null ? (React.createElement(React.Fragment, null,
                React.createElement(View, { style: {
                        width: '100%'
                    } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: `You have no capital gains on non-equity mutual funds in financial year ${toDate.substring(toDate.length - 4)}-${fromDate.substring(fromDate.length - 2)}`, color: ColorTokens.Grey_Charcoal })))) : (React.createElement(View, { style: {
                    width: '100%',
                    borderWidth: 1,
                    borderRadius: 8,
                    borderColor: colorMapping[ColorTokens.Grey_Chalk],
                    padding: 16
                } },
                _data?.nonEquityLongTermCapitalGain !== null &&
                    React.createElement(React.Fragment, null,
                        renderItems({
                            label: 'Long term capital gain (with indexation)',
                            value: `₹${addCommasToNumber(_data?.nonEquityLongTermCapitalGain)}`,
                            keyName: 'nonEquityLongTermCapitalGain',
                            breakLabel1: 'Long term capital gain ',
                            breakLabel2: '(with indexation)'
                        }),
                        React.createElement(Space, { size: SizeTypeTokens.XL })),
                _data?.nonEquityLongTermCapitalTaxPercentage !== null &&
                    React.createElement(React.Fragment, null,
                        renderItems({
                            label: 'Tax%*',
                            value: `${_data?.nonEquityLongTermCapitalTaxPercentage}%`,
                            keyName: 'nonEquityLongTermCapitalTaxPercentage',
                        }),
                        React.createElement(Space, { size: SizeTypeTokens.XL })),
                renderDivider(),
                React.createElement(Space, { size: SizeTypeTokens.XL }),
                _data?.nonEquityLongTermCapitalGainAsPerTaxSlab !== null &&
                    renderItems({
                        label: 'Capital gains taxed as per income tax slab rates',
                        value: `₹${addCommasToNumber(_data?.nonEquityLongTermCapitalGainAsPerTaxSlab)}`,
                        keyName: 'nonEquityLongTermCapitalGainAsPerTaxSlab',
                        breakLabel1: 'Capital gains taxed as per',
                        breakLabel2: 'income tax slab rates'
                    }))))));
    };
    const renderCard = () => {
        const renderItem = [
            'Get scheme wise summary of short or long term capital gains/losses',
            'Get details of each transaction along with capital gain/loss incurred ',
            'Get advanced details such indexed cost, grandfathered units, etc '
        ];
        return useMemo(() => (React.createElement(React.Fragment, null,
            React.createElement(View, { style: {
                    width: '100%',
                    borderTopWidth: 1,
                    borderLeftWidth: 1,
                    borderRightWidth: 1,
                    borderTopRightRadius: 8,
                    borderTopLeftRadius: 8,
                    borderColor: colorMapping[ColorTokens.Grey_Chalk],
                    backgroundColor: colorMapping[ColorTokens.White],
                    padding: 16,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                } },
                React.createElement(Image, { uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/excelcgst.svg', size: ImageSizeTokens.Size_60, width: _isMobile ? 32 : 40, height: _isMobile ? 23 : 40 }),
                React.createElement(Space, { size: SizeTypeTokens.LG }),
                React.createElement(Typography, { label: 'Detailed capital gain report', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: {
                    width: '100%',
                    borderWidth: 1,
                    borderBottomRightRadius: 8,
                    borderBottomLeftRadius: 8,
                    borderColor: colorMapping[ColorTokens.Grey_Chalk],
                    backgroundColor: colorMapping[ColorTokens.Grey_Milk],
                    padding: 16
                } },
                renderItem.map((item) => (React.createElement(React.Fragment, null,
                    React.createElement(View, { style: {
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center'
                        } },
                        React.createElement(Image, { uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/cgstTick.svg', size: ImageSizeTokens.Size_60, width: 16, height: 16 }),
                        React.createElement(Space, { size: SizeTypeTokens.MD }),
                        React.createElement(Typography, { label: `${item}`, typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Night })),
                    React.createElement(Space, { size: SizeTypeTokens.XL })))),
                React.createElement(View, { style: {
                        width: 197
                    } },
                    React.createElement(Button, { label: 'Download report ', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.LARGE, loading: downloadBtnLoading, onPress: async () => {
                            setDownloadButtonLoading(true);
                            setTimeout(async () => {
                                downloadAction &&
                                    await triggerAction({
                                        ...downloadAction,
                                        payload: {
                                            ...downloadAction.payload,
                                            downloadURL: _data?.cgsReportExcelPath
                                        }
                                    });
                                setDownloadButtonLoading(false);
                            }, 1000);
                        } }))))), [_data, downloadBtnLoading]);
    };
    const renderImage = (uri) => {
        return useMemo(() => (React.createElement(React.Fragment, null,
            React.createElement(Image, { size: ImageSizeTokens.XS, width: _isMobile ? 24 : 26, height: _isMobile ? 24 : 26, uri: `${uri}` }))), [
            _data
        ]);
    };
    const header = () => {
        return (React.createElement(View, { style: {
                width: '100%',
                paddingHorizontal: _isMobile ? 16 : 40,
                paddingVertical: 16,
                backgroundColor: colorMapping[ColorTokens.Secondary_10]
            } },
            React.createElement(Typography, { label: '✨ Capital gains statement is ready!', typeDLS: _isMobile ? TypographyTypeDLS.H3S : TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.center }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(View, { style: {
                    height: 1,
                    width: '100%',
                    backgroundColor: colorMapping[ColorTokens.Secondary_20]
                } }),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                } },
                React.createElement(View, { style: {
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: _isMobile ? 32 : 48,
                        width: _isMobile ? 32 : 48,
                        backgroundColor: colorMapping[ColorTokens.Secondary_20],
                        borderRadius: 50
                    } }, renderImage('https://volt-images-alpha.s3.ap-south-1.amazonaws.com/cgstCard1.svg')),
                React.createElement(Space, { size: _isMobile ? SizeTypeTokens.MD : SizeTypeTokens.XL }),
                React.createElement(View, { style: {
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    } },
                    React.createElement(View, null,
                        React.createElement(Typography, { label: `For ${pan} / +91${phone} `, typeDLS: _isMobile
                                ? TypographyTypeDLS.B2R
                                : TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night }),
                        React.createElement(Space, { size: _isMobile ? SizeTypeTokens.SM : SizeTypeTokens.MD }),
                        React.createElement(Typography, { label: _isMobile ?
                                `FY: ${formatDate(fromDate)} - ${formatDate(toDate)} `
                                : `Financial year: ${formatDate(fromDate)} - ${formatDate(toDate)} `, typeDLS: _isMobile
                                ? TypographyTypeDLS.B2R
                                : TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night })),
                    React.createElement(View, null,
                        React.createElement(TouchableOpacity, { style: {
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }, onPress: async () => {
                                editAction &&
                                    await triggerAction(editAction);
                            } },
                            React.createElement(Typography, { label: _isMobile
                                    ? 'Edit'
                                    : 'Edit Details', typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100 }),
                            React.createElement(Icon, { name: IconTokens.SYSTEM_CHEVRON_RIGHT_DLS, size: IconSizeTokens.XXL })))))));
    };
    const renderInfoBanner = () => {
        return (React.createElement(View, { style: {
                backgroundColor: '#FEF4E6',
                paddingHorizontal: 12,
                paddingVertical: 8,
                display: 'flex',
                flexDirection: 'row',
                borderRadius: 8
            } },
            React.createElement(View, { style: {
                    width: 24,
                    height: 24,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                } },
                React.createElement(Icon, { name: IconTokens.SYSTEM_INFO_DLS, color: ColorTokens.Warning_100, size: IconSizeTokens.XXL })),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(Typography, { label: 'Currently, capital gains are available for investments with individual ownership. Support for joint or anyone survivor ownership is coming soon!', typeDLS: TypographyTypeDLS.B2R, color: ColorTokens.Grey_Night })));
    };
    const body = () => {
        return (React.createElement(Pressable, { style: {
                width: '100%',
                paddingHorizontal: _isMobile ? 16 : 40,
                paddingVertical: 24,
                backgroundColor: colorMapping[ColorTokens.White]
            }, onPress: () => {
                setFocusToolTipName(undefined);
            } },
            React.createElement(Typography, { label: 'Summary', typeDLS: TypographyTypeDLS.H4S, color: ColorTokens.Grey_Night }),
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            renderEquity(),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            renderNonEquity(),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            renderInfoBanner(),
            React.createElement(Space, { size: SizeTypeTokens.Size32 }),
            renderDivider(),
            React.createElement(Space, { size: SizeTypeTokens.Size32 }),
            renderCard()));
    };
    return (React.createElement(View, { style: [
            styles.container,
            {
                width: '100%',
                backgroundColor: colorMapping[ColorTokens.White]
            }
        ] },
        header(),
        body()));
};
const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
};
export default CgtcSummaryPage;
